import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { InputControl, TextField } from '@/components';
import { useDebounce, useResolveValue } from '@/hooks';
import { ValuesType } from '@/types';
import { REGEX, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
const ALLOWED_KEYS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'ArrowLeft',
    'ArrowRight',
    'Backspace',
    'Delete',
    'End',
    'Enter',
    'Home',
    'Tab'
];
export const WholeNumberField = ({ block: { answer, id, key, layout, placeholder_text, required }, defaultValue = null, errors = [], onChange }) => {
    useEffect(() => {
        inputRef.current.value = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toString()) || '';
    }, [defaultValue]);
    const inputRef = useRef(null);
    const [resolver] = useResolveValue();
    const resolved = {
        label: resolver.resolveString(answer.label),
        placeholder: resolver.resolveString(placeholder_text),
        required: resolver.resolveBoolean(required)
    };
    const debouncedValue = useDebounce(defaultValue, 500);
    const isInvalid = (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && defaultValue !== null && debouncedValue !== null;
    const handleChange = (e) => {
        const value = e.target.value.replace(REGEX.NON_NUMERIC_CHARACTERS, '');
        inputRef.current.value = value;
        const answerValue = Object.assign(Object.assign({}, answer), { label: resolved.label, value: value === '' ? null : Number(value) });
        const newAnswer = getInputBlockAnswer(ValuesType.INTEGER, answerValue, key);
        onChange(newAnswer);
    };
    const handlePaste = (e) => {
        e.preventDefault();
    };
    const handleInvalidChar = (e) => {
        // let shortcuts such as select all and copy through
        if (e.ctrlKey || e.metaKey)
            return;
        if (!ALLOWED_KEYS.includes(e.key))
            e.preventDefault();
    };
    return (_jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputControl, Object.assign({ "data-test": id, isInvalid: isInvalid, isRequired: resolved.required, label: resolved.label }, { children: _jsx(TextField, { "data-test": answer.id, defaultValue: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toString()) || '', error: errors[0] || '', inputMode: 'numeric', onChange: handleChange, onKeyDown: handleInvalidChar, onPaste: handlePaste, placeholder: resolved.placeholder, ref: inputRef, type: 'text' }) })) })));
};
